@import '../../../../constants/spacing.module.less';

.header-content {
  flex: 1;

  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: @space-16;
}

.action-dropdown {
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  min-height: 16px;
  gap: @space-4;
}

.ship-date-dropdown-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  // This makes the dropdown icon more inline with our standard dropdown icons
  width: 8px;
  height: 16px;
  margin: 0 5px 0 3px;
}
